<template>
  <div style="width:300px;height:1000px">
    <div class="wrapper">
      <multipleselect v-bind:optionsdata="multiple.originOptions" v-bind:selecteddata="multiple.selectedList"
        v-on:selected="multipleCallback" ref="mselect">
      </multipleselect>
    </div>
    <div class="wrapper" style="display: none;">
      <div class="functional-select-wrapper">
        <!-- 展示 -->
        <label class="display-container multiple-select-container clearfix" for="multiple-select-input">
          <p class="multiple-selected-item">lemon<i>×</i></p>
          <input class="multiple-select-input" id="multiple-select-input">
        </label>
        <!-- 下拉 -->
        <div class="options-container">
          <ul class="options-ul-list">
            <li>123</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="../static/js/lib/vue.min.js"></script>
<script type="text/javascript" src="../static/js/select-vue-component.js"></script>
<script>
  //数据库传了所有线路到这里，贴到originalOptions里面
  import multipleselect from "./select_vue_component.vue";
  import bus_line_info from "./bus_line_info.vue";
  var originalOptions = [];
  export default {
    name: 'multiple_choice_search',
    props: ['num_line', 'line_name'],
    data() {
      return {
        multiple: {
          originOptions: originalOptions,
          selectedList: [1, 2, 3],
          //linesInfo: [],
        },
      }
    },
    mounted: function() {
      this.queryData();
    },
    methods: {
      queryData: function() {
        var mySelf = this
        //do ajax here
        var bus_line = JSON.parse(sessionStorage.getItem('Bus_Line'));
        // 多选
        var norm_bus_line = this.formatOriginOptions(bus_line);
        mySelf.multiple.originOptions = this.formatOriginOptions(bus_line); //附初值
        if (norm_bus_line.length > 10) {
          mySelf.multiple.selectedList = norm_bus_line.slice(0, 10);
        } else {
          mySelf.multiple.selectedList = norm_bus_line;
        }
      },
      toPercent: function(point) {
        var str = Number(point * 100).toFixed(0);
        str += "%";
        return str;
      },
      formatOriginOptions: function(bus_line) {

        var bus_lines = [];
        for (let ele in bus_line) {
          var norm_bus_line = {
            "id": 0,
            "name": "default",
            "rate": "default",
            "format_code": [0],
          };
          norm_bus_line.id = bus_line[ele].bus_id;
          norm_bus_line.name = bus_line[ele].bus_name;
          norm_bus_line.rate = this.toPercent(bus_line[ele].value_rating);
          norm_bus_line.format_code = bus_line[ele].format_code;
          bus_lines.push(norm_bus_line);
        }
        return bus_lines;
      },

      multipleCallback: function(data) {
        this.multiple.selectedList = data;
      },

    },
    components: {
      multipleselect,
      bus_line_info
    }
  }
</script>
